import { Box } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { CustomTextarea } from './styles';

interface TextareaProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  name: string;
  placeholder?: string;
  disabled?: boolean;
}

function Textarea<TFieldValues extends FieldValues = FieldValues>({ control, name, placeholder, disabled }: TextareaProps<TFieldValues>) {
  return (
    <Controller
      render={({ field }) => (
        <Box sx={{ width: '100%' }}>
          <CustomTextarea
            id={name}
            placeholder={placeholder || 'Enter'}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              field.onChange(e);
            }}
            value={field.value ?? ''}
            disabled={disabled}
            minRows={5}
            sx={{ width: '100%' }}
          />
        </Box>
      )}
      name={name as Path<TFieldValues>}
      control={control}
    />
  );
}

export default Textarea;
